<template>
  <nav class="navbar-expand-md menu-log" id="menu-log">
    <div class="container">
      <div class="navbar-collapse acount_menu_mobile" id="logMenu">
        <ul class="navbar-nav ml-auto">
          <li :class="[currentPage == '/account/surveys' ? 'active':'','nav-item']">
            <div class="row">
              <img src="../assets/img/surveys-icon.png" class="img my-auto" alt="">
              <router-link :to="{name:'account-surveys-view'}" class="nav-link text-nowrap">
                {{$t('panel.surveys')}}
              </router-link>
            </div>
          </li>
          <li :class="[currentPage == '/account/consultations' ? 'active':'','nav-item']">
            <div class="row">
              <img src="../assets/img/med-cons-icon.png" class="img my-auto" alt="">
              <router-link :to="{name:'account-consultations-view'}" class="nav-link text-nowrap">
                {{$t('panel.appointments')}}
              </router-link>
            </div>
          </li>
          <li :class="[currentPage == '/account' ? 'active':'','nav-item']">
            <div class="row">
              <img src="../assets/img/my-account-icon.png" class="img my-auto" alt="">
              <router-link :to="{name:'account-view'}" class="nav-link text-nowrap">{{$t('panel.my_account')}}</router-link>
            </div>
          </li>
          <li :class="[currentPage == '/account/analysis' ? 'active':'','nav-item']">
            <div class="row">
              <img src="../assets/img/my-analysis-icon.png" class="img my-auto" alt="">
              <router-link :to="{name:'account-analysis-view'}" class="nav-link text-nowrap">
                {{$t('panel.my_analysis')}}
              </router-link>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
  export default {
    name: "Panel",
    computed: {
      currentPage() {
        return this.$route.path;
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Panel.vue